import { getApiActionTypes } from 'store/utils/actions';

export const FETCH_FOLIO = getApiActionTypes('FETCH_FOLIO');
